/** Structured scoring catalogue + legacy chapter filter for navigation. */
import { voidfallChapters } from './content';
export {
  voidfallScoringRecords,
  filterVoidfallScoring,
  validateVoidfallScoringTables,
} from './scoringTables';
export type {
  VoidfallScoringRecord,
  VoidfallScoringModuleId,
} from './scoringTables';

/** Chapters whose titles mention scoring — for chapter-based navigation. */
export const voidfallScoring = voidfallChapters.filter((chapter) =>
  /punkt|scor/i.test(chapter.title)
);
